(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--announcement-bar"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-announcement-bar-section')){
  class StackAnnouncementBarSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.blocks = null;
      this.autoRotate = false;
      this.displayDuration = 5000;
      this.currentIndex = 0;
      this.rotationInterval = null;
      this.countdownIntervals = [];
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack?.isChecked||!window.stack.isChecked()){
        setTimeout(()=>{
          if(!window.stack?.check||window.stack.check()===false){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }
      if(!window.stack?.check||window.stack.check()===false){
        this.remove();
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      this.blocks = this.querySelectorAll('.stack--announcement-bar-block');
      if (this.blocks.length <= 1) return;

      this.autoRotate = this.dataset.autoRotate === 'true';
      this.displayDuration = parseInt(this.dataset.displayDuration) || 5000;

      this.initCountdownTimers();
      this.initCopyButtons();
      this.initNavigation();
      this.initHoverControls();
      this.startRotation();

      this.initialized = true;
    }

    showBlock(index) {
      this.blocks.forEach((block, i) => {
        block.classList.toggle('stack--announcement-bar-active', i === index);
      });
      this.currentIndex = index;
    }

    nextBlock() {
      const nextIndex = (this.currentIndex + 1) % this.blocks.length;
      this.showBlock(nextIndex);
    }

    prevBlock() {
      const prevIndex = this.currentIndex === 0 ? this.blocks.length - 1 : this.currentIndex - 1;
      this.showBlock(prevIndex);
    }

    startRotation() {
      this.stopRotation();
      if (this.autoRotate) {
        this.rotationInterval = setInterval(() => {
          this.nextBlock();
        }, this.displayDuration);
      }
    }

    stopRotation() {
      if (this.rotationInterval) {
        clearInterval(this.rotationInterval);
        this.rotationInterval = null;
      }
    }

    initNavigation() {
      const nextBtn = this.querySelector('.stack--announcement-bar-next');
      const prevBtn = this.querySelector('.stack--announcement-bar-prev');

      if (nextBtn) {
        nextBtn.addEventListener('click', () => {
          this.stopRotation();
          this.nextBlock();
          setTimeout(() => this.startRotation(), 500);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', () => {
          this.stopRotation();
          this.prevBlock();
          setTimeout(() => this.startRotation(), 500);
        });
      }
    }

    initHoverControls() {
      this.addEventListener('mouseenter', () => this.stopRotation());
      this.addEventListener('mouseleave', () => this.startRotation());
    }

    initCountdownTimers() {
      const countdownElements = this.querySelectorAll('.stack--announcement-bar-time[data-target-date]');

      countdownElements.forEach(element => {
        const targetDate = new Date(element.dataset.targetDate);

        const updateCountdown = () => {
          const now = new Date().getTime();
          const distance = targetDate.getTime() - now;

          if (distance < 0) {
            element.querySelector('.stack--announcement-bar-countdown').innerHTML = '0:00:00';
            return;
          }

          const days = Math.floor(distance / (1000 * 60 * 60 * 24));
          const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
          const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((distance % (1000 * 60)) / 1000);

          const daysEl = element.querySelector('.stack--announcement-bar-days');
          const daysSeparatorEl = element.querySelector('.stack--announcement-bar-days-separator');
          const hoursEl = element.querySelector('.stack--announcement-bar-hours');
          const minutesEl = element.querySelector('.stack--announcement-bar-minutes');
          const secondsEl = element.querySelector('.stack--announcement-bar-seconds');

          // Show/hide days based on whether there are any
          if (daysEl && daysSeparatorEl) {
            if (days > 0) {
              daysEl.style.display = 'inline';
              daysSeparatorEl.style.display = 'inline';
              daysEl.textContent = days;
            } else {
              daysEl.style.display = 'none';
              daysSeparatorEl.style.display = 'none';
            }
          }

          if (hoursEl) hoursEl.textContent = hours.toString().padStart(2, '0');
          if (minutesEl) minutesEl.textContent = minutes.toString().padStart(2, '0');
          if (secondsEl) secondsEl.textContent = seconds.toString().padStart(2, '0');
        };

        updateCountdown();
        const intervalId = setInterval(updateCountdown, 1000);
        this.countdownIntervals.push(intervalId);
      });
    }

    initCopyButtons() {
      const discountWrappers = this.querySelectorAll('.stack--announcement-bar-discount-wrapper');

      discountWrappers.forEach(wrapper => {
        const copyButton = wrapper.querySelector('.stack--announcement-bar-copy-btn');

        if (copyButton) {
          const code = copyButton.dataset.code;
          wrapper.style.cursor = 'pointer';

          const copyToClipboard = () => {
            if (navigator.clipboard) {
              navigator.clipboard.writeText(code).then(() => {
                this.showCopyFeedback(copyButton);
              }).catch(() => {
                this.fallbackCopy(code, copyButton);
              });
            } else {
              this.fallbackCopy(code, copyButton);
            }
          };

          copyButton.addEventListener('click', (e) => {
            e.stopPropagation();
            copyToClipboard();
          });

          wrapper.addEventListener('click', (e) => {
            if (e.target !== copyButton) {
              copyToClipboard();
            }
          });
        }
      });
    }

    fallbackCopy(code, button) {
      const textArea = document.createElement('textarea');
      textArea.value = code;
      textArea.style.position = 'fixed';
      textArea.style.left = '-999999px';
      textArea.style.top = '-999999px';
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        this.showCopyFeedback(button);
      } catch (err) {
        console.error('Failed to copy text: ', err);
      }

      document.body.removeChild(textArea);
    }

    showCopyFeedback(button) {
      const originalHTML = button.innerHTML;

      button.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      button.classList.add('copied');

      setTimeout(() => {
        button.innerHTML = originalHTML;
        button.classList.remove('copied');
      }, 2000);
    }

    disconnectedCallback() {
      this.stopRotation();
      this.countdownIntervals.forEach(intervalId => clearInterval(intervalId));
      this.countdownIntervals = [];
      this.initialized = false;
    }
  }

  customElements.define('stack-announcement-bar-section', StackAnnouncementBarSection);
}

// Handle Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId.includes('stack--announcement-bar')) {
    const section = document.querySelector('.stack--announcement-bar');
    if (section && section.tagName.toLowerCase() === 'stack-announcement-bar-section') {
      setTimeout(() => section.init(), 100);
    }
  }
});

document.addEventListener('shopify:section:select', function(event) {
  if (event.detail.sectionId.includes('stack--announcement-bar')) {
    const section = document.querySelector('.stack--announcement-bar');
    if (section && section.tagName.toLowerCase() === 'stack-announcement-bar-section') {
      section.init();
    }
  }
});

document.addEventListener('shopify:section:deselect', function(event) {
  if (event.detail.sectionId.includes('stack--announcement-bar')) {
    const section = document.querySelector('.stack--announcement-bar');
    if (section && section.tagName.toLowerCase() === 'stack-announcement-bar-section') {
      const blocks = section.querySelectorAll('.stack--announcement-bar-block');
      blocks.forEach(block => {
        block.style.animation = 'none';
      });
    }
  }
});

document.addEventListener('shopify:theme:section:reorder', function(event) {
  if (event.detail.sectionId.includes('stack--announcement-bar')) {
    const section = document.querySelector('.stack--announcement-bar');
    if (section && section.tagName.toLowerCase() === 'stack-announcement-bar-section') {
      setTimeout(() => section.init(), 100);
    }
  }
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--faq"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-faq-section')){
  class StackFAQSection extends HTMLElement {
    constructor() {
      super();
      this.resizeTimeout = null;
      this.initialized = false;
      this.boundHandleResize = this.handleResize.bind(this);
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack?.isChecked||!window.stack.isChecked()){
        setTimeout(()=>{
          if(!window.stack?.check||window.stack.check()===false){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }
      if(!window.stack?.check||window.stack.check()===false){
        this.remove();
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      const faqQuestions = this.querySelectorAll('.stack--faq-question');
      if (faqQuestions.length === 0) return;

      // Set initial heights
      this.setHeights();

      // Setup resize listener
      window.addEventListener('resize', this.boundHandleResize);

      // Setup click handlers
      faqQuestions.forEach(question => {
        question.addEventListener('click', this.handleQuestionClick.bind(this));
      });

      this.initialized = true;
    }

    handleResize() {
      clearTimeout(this.resizeTimeout);
      this.resizeTimeout = setTimeout(() => this.setHeights(), 200);
    }

    setHeights() {
      const answers = this.querySelectorAll('.stack--faq-answer');
      answers.forEach(answer => {
        const inner = answer.querySelector('.stack--faq-answer-inner');
        if (!inner) return;
        
        if (answer.getAttribute('aria-hidden') === 'false') {
          answer.style.height = inner.offsetHeight + 'px';
        } else {
          answer.style.height = '0px';
        }
      });
    }

    handleQuestionClick(event) {
      const question = event.currentTarget;
      const expanded = question.getAttribute('aria-expanded') === 'true';
      const answerId = question.getAttribute('aria-controls');
      const answer = document.getElementById(answerId);
      if (!answer) return;
      
      const answerInner = answer.querySelector('.stack--faq-answer-inner');
      if (!answerInner) return;

      // Toggle current FAQ item
      question.setAttribute('aria-expanded', !expanded);
      answer.setAttribute('aria-hidden', expanded);

      // Smooth height animation
      if (expanded) {
        answer.style.height = '0px';
      } else {
        answer.style.height = answerInner.offsetHeight + 'px';
      }

      // Close other items (accordion behavior)
      if (!expanded) {
        const allQuestions = this.querySelectorAll('.stack--faq-question');
        allQuestions.forEach(otherQuestion => {
          if (otherQuestion !== question) {
            const otherAnswerId = otherQuestion.getAttribute('aria-controls');
            const otherAnswer = document.getElementById(otherAnswerId);
            if (!otherAnswer) return;

            otherQuestion.setAttribute('aria-expanded', 'false');
            otherAnswer.setAttribute('aria-hidden', 'true');
            otherAnswer.style.height = '0px';
          }
        });
      }
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.boundHandleResize);
      this.initialized = false;
    }
  }

  customElements.define('stack-faq-section', StackFAQSection);
}

// Handle Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId.includes('stack--faq')) {
    const section = document.querySelector('.stack--faq');
    if (section && section.tagName.toLowerCase() === 'stack-faq-section') {
      setTimeout(() => section.init(), 100);
    }
  }
});

document.addEventListener('shopify:section:select', function(event) {
  if (event.detail.sectionId.includes('stack--faq')) {
    const section = document.querySelector('.stack--faq');
    if (section && section.tagName.toLowerCase() === 'stack-faq-section') {
      section.init();
    }
  }
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--shoppable-slides"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-shoppable-slides-section')){
class StackShoppableSlidesSection extends HTMLElement {
constructor() {
super();
this.initialized = false;
this.swiper = null;
this.currentlyPlayingVideo = null;
}

connectedCallback() {
if(!window.stack?.isChecked||!window.stack.isChecked()){
setTimeout(()=>{
 if(!window.stack?.check||window.stack.check()===false){
   this.remove();
 } else {
   this.init();
 }
},100);
return;
}
if(!window.stack?.check||window.stack.check()===false){
this.remove();
return;
}
requestAnimationFrame(() => this.init());
}

init() {
if (this.initialized) return;

// Add initial load class for animation
if (this.classList.contains('stack--shoppable-slides-fade')) {
this.classList.add('stack--shoppable-slides-initial-load');
// Remove after animation completes
setTimeout(() => {
 this.classList.remove('stack--shoppable-slides-initial-load');
}, 1500);
}

this.initSwiperSlider();
this.initVideoControls();

this.initialized = true;
}

initSwiperSlider() {
const swiperContainer = this.querySelector('.stack--shoppable-slides-swiper');
if (!swiperContainer) return;

// Wait for Swiper library to load
if (typeof Swiper === 'undefined') {
setTimeout(() => this.initSwiperSlider(), 100);
return;
}

const autoplayEnabled = this.dataset.autoplay === 'true';
const coverflowEnabled = this.dataset.coverflow === 'true';
const swiperId = swiperContainer.id;

// Initialize Swiper configuration
const swiperConfig = {
grabCursor: true,
centeredSlides: true,
slidesPerView: 'auto',
spaceBetween: 20,
loop: true,
loopAddBlankSlides: true,
loopAdditionalSlides: 3,
speed: 600,

// Navigation (scoped to this specific swiper)
navigation: {
 nextEl: this.querySelector('.swiper-button-next'),
 prevEl: this.querySelector('.swiper-button-prev'),
},

// Autoplay (optional)
...(autoplayEnabled && {
 autoplay: {
   delay: 5000,
   disableOnInteraction: false,
   pauseOnMouseEnter: true,
 },
}),

// Coverflow effect (optional)
...(coverflowEnabled && {
 effect: 'coverflow',
 coverflowEffect: {
   rotate: 0,
   stretch: 0,
   depth: 85,
   modifier: 1,
   slideShadows: true,
 },
}),

// Accessibility
a11y: {
 enabled: true,
 prevSlideMessage: 'Previous video',
 nextSlideMessage: 'Next video',
 firstSlideMessage: 'This is the first video',
 lastSlideMessage: 'This is the last video',
},

// Keyboard control
keyboard: {
 enabled: true,
 onlyInViewport: true,
},

// Responsive breakpoints
breakpoints: {
 1024: {
   spaceBetween: 50,
 },
 768: {
  spaceBetween: 40,
 }
},

// Prevent animation on init
runCallbacksOnInit: false,

// On slide change, stop all videos
on: {
 slideChange: () => {
   this.stopAllVideos();
 },
},
};

// Initialize Swiper with unique ID
this.swiper = new Swiper(`#${swiperId}`, swiperConfig);
}

initVideoControls() {
const slides = this.querySelectorAll('.swiper-slide');

slides.forEach((slide) => {
 const video = slide.querySelector('.stack--shoppable-slides-video');
 const playButton = slide.querySelector('.stack--shoppable-slides-play-button');
 const playIcon = slide.querySelector('#iconPlay');
 const pauseIcon = slide.querySelector('#iconPause');

 if (!video || !playButton || !playIcon || !pauseIcon) return;

 // Play/Pause on button click
 playButton.addEventListener('click', (e) => {
   e.stopPropagation();
   
   // Only allow interaction on active, prev, or next slides
   if (
     slide.classList.contains('swiper-slide-active') ||
     slide.classList.contains('swiper-slide-next') ||
     slide.classList.contains('swiper-slide-prev')
   ) {
     // Stop other videos first
     if (this.currentlyPlayingVideo && this.currentlyPlayingVideo !== video) {
       this.stopVideo(this.currentlyPlayingVideo);
     }

     // Toggle current video
     if (video.paused) {
       video.volume = 0.4;
       video.play();
       playIcon.style.display = 'none';
       pauseIcon.style.display = 'block';
       playButton.setAttribute('aria-label', 'Pause video');
       this.currentlyPlayingVideo = video;
     } else {
       this.stopVideo(video);
     }
   }
 });

 // Reset video when it ends
 video.addEventListener('ended', () => {
   video.currentTime = 0;
   playIcon.style.display = 'block';
   pauseIcon.style.display = 'none';
   playButton.setAttribute('aria-label', 'Play video');
   if (this.currentlyPlayingVideo === video) {
     this.currentlyPlayingVideo = null;
   }
 });
});
}

stopVideo(video) {
if (!video) return;

const slide = video.closest('.swiper-slide');
if (!slide) return;

const playIcon = slide.querySelector('#iconPlay');
const pauseIcon = slide.querySelector('#iconPause');
const playButton = slide.querySelector('.stack--shoppable-slides-play-button');

video.pause();
if (playIcon) playIcon.style.display = 'block';
if (pauseIcon) pauseIcon.style.display = 'none';
if (playButton) playButton.setAttribute('aria-label', 'Play video');

if (this.currentlyPlayingVideo === video) {
 this.currentlyPlayingVideo = null;
}
}

stopAllVideos() {
const videos = this.querySelectorAll('.stack--shoppable-slides-video');
videos.forEach(video => this.stopVideo(video));
}

disconnectedCallback() {
// Cleanup Swiper instance
if (this.swiper && this.swiper.destroy) {
this.swiper.destroy(true, true);
}
this.stopAllVideos();
this.initialized = false;
}
}

customElements.define('stack-shoppable-slides-section', StackShoppableSlidesSection);
}

// Handle Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
if (event.detail.sectionId.includes('stack--shoppable-slides')) {
const section = document.querySelector('stack-shoppable-slides-section');
if (section) {
setTimeout(() => section.init(), 100);
}
}
});

document.addEventListener('shopify:section:select', function(event) {
if (event.detail.sectionId.includes('stack--shoppable-slides')) {
const section = document.querySelector('stack-shoppable-slides-section');
if (section) {
section.init();
}
}
});
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stack--testimonials"] && !Shopify.designMode) return;
  try {
    
(async()=>{
if(!customElements.get('stack-testimonials-section')){
  class StackTestimonialsSection extends HTMLElement {
    constructor() {
      super();
      this.initialized = false;
      this.swiper = null;
    }

    connectedCallback() {
      // Security check with deferred initialization
      if(!window.stack?.isChecked||!window.stack.isChecked()){
        setTimeout(()=>{
          if(!window.stack?.check||window.stack.check()===false){
            this.remove();
          } else {
            this.init();
          }
        },100);
        return;
      }
      if(!window.stack?.check||window.stack.check()===false){
        this.remove();
        return;
      }

      // Initialize immediately if security check passes
      requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.initialized) return;
      
      const layout = this.dataset.layout;
      
      if (layout === 'stack') {
        this.initStackViewMore();
      } else if (layout === 'slider') {
        this.initSwiperSlider();
      }

      this.initialized = true;
    }

    initStackViewMore() {
      const viewMoreBtn = this.querySelector('.stack--testimonials-view-more-btn');
      if (!viewMoreBtn) return;
      
      viewMoreBtn.addEventListener('click', () => {
        const hiddenCards = this.querySelectorAll('.stack--testimonials-card-hidden');
        hiddenCards.forEach(card => {
          card.classList.remove('stack--testimonials-card-hidden');
        });
        viewMoreBtn.parentElement.style.display = 'none';
      });
    }

    initSwiperSlider() {
      const swiperContainer = this.querySelector('.stack--testimonials-swiper');
      if (!swiperContainer) return;
      
      // Wait for Swiper library to load
      if (typeof Swiper === 'undefined') {
        setTimeout(() => this.initSwiperSlider(), 100);
        return;
      }
      
      // Initialize Swiper with configuration
      this.swiper = new Swiper('.stack--testimonials-swiper', {
        // Basic settings
        loop: true,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false,
          pauseOnMouseEnter: true,
        },
        speed: 600,
        // Navigation
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        centeredSlides: false,
        slidesPerView: 'auto',
        
        // Accessibility
        a11y: {
          enabled: true,
          prevSlideMessage: 'Previous testimonial',
          nextSlideMessage: 'Next testimonial',
          firstSlideMessage: 'This is the first testimonial',
          lastSlideMessage: 'This is the last testimonial',
        },
        
        // Keyboard control
        keyboard: {
          enabled: true,
          onlyInViewport: true,
        },
        
        // Touch/Swipe
        touchRatio: 1,
        touchAngle: 45,
        grabCursor: true,
        touchStartPreventDefault: false,
        
        // Effects
        effect: 'slide',
        fadeEffect: {
          crossFade: true,
        },
      });
    }

    disconnectedCallback() {
      // Cleanup Swiper instance
      if (this.swiper && this.swiper.destroy) {
        this.swiper.destroy(true, true);
      }
      this.initialized = false;
    }
  }

  customElements.define('stack-testimonials-section', StackTestimonialsSection);
}

// Handle Shopify theme editor events
document.addEventListener('shopify:section:load', function(event) {
  if (event.detail.sectionId.includes('stack--testimonials')) {
    const section = document.querySelector('.stack--testimonials');
    if (section && section.tagName.toLowerCase() === 'stack-testimonials-section') {
      setTimeout(() => section.init(), 100);
    }
  }
});

document.addEventListener('shopify:section:select', function(event) {
  if (event.detail.sectionId.includes('stack--testimonials')) {
    const section = document.querySelector('.stack--testimonials');
    if (section && section.tagName.toLowerCase() === 'stack-testimonials-section') {
      section.init();
    }
  }
});
})();

  } catch(e) { console.error(e); }
})();
})();
